// extracted by mini-css-extract-plugin
module.exports = {"imgAckStatusOverlay":"attendance-detail-modal_imgAckStatusOverlay__38vc-"};